import { useTranslation } from "@msuite/ui/localization";
import { responseHandler } from "@msuite/ui/utils";
import type { PatchDocumentBody } from "@msuite/utils/schemas";
import { Documents, ImportOfferAction } from "@/components/documents";
import { client } from "@/hono";
import { useProject } from "@/hooks/use-project";
import type { ProjectPanelBaseProps } from "../types";

/** Props Interface */
interface ProjectDocumentsProps extends ProjectPanelBaseProps {}

export function ProjectDocuments({ projectId }: ProjectDocumentsProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { project } = useProject({ projectId });

	/** Functions */
	async function handleOnPatchDocument(documentId: string, json: PatchDocumentBody) {
		const response = await client.documents[":documentFilesTable"][":documentId"].$patch({
			param: { documentFilesTable: "projectDocumentFiles", documentId },
			json,
		});
		await responseHandler(response);
	}

	/** Render */
	return (
		<Documents
			identifier={projectId}
			documentFilesTable="projectDocumentFiles"
			parent={project ? { subject: "Project", resource: project } : undefined}
			onPatchDocument={handleOnPatchDocument}
			menu={ImportOfferAction}
			typeOptions={[
				{
					value: "default",
					label: t("general.standard"),
				},
				{
					value: "risk-assessment",
					label: t("users.risk_assessment"),
				},
			]}
		/>
	);
}
